import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import common_sv from "./translations/sv/common.json";
import common_en from "./translations/en/common.json";
import common_it from "./translations/it/common.json";

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: "sv", // language to use
  resources: {
    en: {
      common: common_en // 'common' is our custom namespace
    },
    sv: {
      common: common_sv
    },
    it: {
      common: common_it
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
